const termsOfService = `
> **Effective Date:** December 23rd 2024

Welcome to Jiwe Esports! By accessing or using our platform (https\://esports.jiwe.io), you agree to comply with and be bound by the following Terms and Conditions. Please read them carefully. If you do not agree, you may not use our platform.


## 1. Introduction

Jiwe Esports (“we,” “us,” “our”) is an online platform designed to host and manage esports tournaments, connect gamers, and build a vibrant gaming community. These Terms and Conditions (“Terms”) govern your use of our platform, website, and related services.


## 2. User Accounts

- **Account Creation:** Users must provide accurate, current, and complete information when creating an account. Users are responsible for maintaining the confidentiality of their account credentials and all activities conducted under their account.

- **Eligibility:** Users must be at least 18 years old to create an account. Users under 18 require parental or guardian consent.

- **Account Suspension:** We reserve the right to suspend or terminate accounts for violating these Terms or engaging in prohibited activities.


## 3. Esports Tournaments and Events

- **Participation:** By joining tournaments or events, users agree to abide by the rules and guidelines specific to each event.

- **Code of Conduct:** Participants must behave respectfully toward other players, organizers, and the community. Harassment, cheating, or disruptive behavior will result in immediate disqualification and potential account suspension.

- **Prizes:** Prize distributions are subject to verification of eligibility and compliance with tournament rules.


## 4. Payments and Transactions

- **Fees:** Jiwe Esports may charge entry fees for certain tournaments. Any applicable fees will be clearly outlined before payment.

- **Refunds:** Refunds are not guaranteed and will be evaluated on a case-by-case basis.

- **Payment Methods:** We support mobile money, credit/debit cards to facilitate transactions.


## 5. Content Ownership and Intellectual Property

- **User Content:** By submitting content (e.g., gameplay videos, chat messages), you grant Jiwe Esports a non-exclusive, worldwide license to display, distribute, and promote your content on the platform.

- **Jiwe Esports Assets:** All branding, logos, and platform designs are the property of Jiwe Esports and cannot be used without authorization.

- **Prohibited Content:** Users may not share content that is offensive, illegal, or violates intellectual property rights.


## 6. User Conduct

Users agree to:

- Respect others within the community.

- Avoid using cheats, hacks, or any tools that provide unfair advantages.

- Report any suspicious behavior or content violations to platform moderators.


## 7. Liability and Disclaimers

- **Limited Liability:** Jiwe Esports is not liable for damages arising from platform use, including loss of data, revenue, or disruptions during tournaments.

- **No Guarantees:** While we aim to ensure fair and smooth gameplay, we cannot guarantee uninterrupted access or error-free operations.


## 8. Privacy Policy

Your use of Jiwe Esports is governed by our Privacy Policy. This document outlines how we collect, use, and protect your data.


## 9. Modifications to the Terms

Jiwe Esports reserves the right to update these Terms at any time. Significant changes will be communicated via email or platform notifications. Continued use of the platform constitutes acceptance of the updated Terms.


## 10. Governing Law and Dispute Resolution

These Terms are governed by the Constitution of Kenya 2010. Any disputes shall be resolved through mediation or arbitration, as agreed upon by the parties involved.


## 11. Contact Information

For questions or concerns regarding these Terms, please contact us at:

- **Email:** rock\@jiwe.io

- **Address:** Basement Floor, The Mall, Westlands, Nairobi, Kenya

`;

export default termsOfService